import { ErrorMesage } from "../../ContributionType/styles";
import React from 'react';
import regexMap from "../../../../../../../utils/regexMap"; 

const firstName = {
  rules:[{
    required: true,
    message: <ErrorMesage>Please enter first name.</ErrorMesage>
    },
    {
      min: 2,
      message: <ErrorMesage>First name is too short.</ErrorMesage>
    },
    {
      max: 150,
      message: <ErrorMesage> Maximum character limit for First Name is 150. Please correct to Proceed. </ErrorMesage>
    }
  ], 
  onchangePattern: /^.{0,150}$/,
  regex: /^.{2,150}$/
}

const lastName = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter last name.</ErrorMesage>
  },
  {
    min: 2,
    message: <ErrorMesage>Last name is too short.</ErrorMesage>
  },
  {
    max: 150,
    message: <ErrorMesage> Maximum character limit for Last Name is 150. Please correct to Proceed. </ErrorMesage>
  }
],onchangePattern: /^.{0,150}$/,
  regex: /^.{2,150}$/ }

const donorType = {rules:[
  {
    required: true,
    message: <ErrorMesage> Please select account type.</ErrorMesage>
  },
  {
    pattern: /^.*\b(Individual|Joint|Trust|Corporation|Private Foundation|Other donor-advised fund)\b.*$/,
    message: <ErrorMesage>Please select account type.</ErrorMesage>
  }
], onchangePattern:/^.*$/,
  regex: /^.*\b(Individual|Joint|Trust|Corporation|Private Foundation|Other donor-advised fund)\b.*$/ }

const name = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter Donor Name.</ErrorMesage>
  },
  {
    min: 2,
    message: <ErrorMesage> Donor name is too short. Please correct to continue.</ErrorMesage>
  },
  {
    max: 100,
    message: <ErrorMesage> Maximum character limit for Name is 100. Please correct to Proceed </ErrorMesage>
  }
], onchangePattern: /^.{0,100}$/,
regex: /^.{2,100}$/ }

const line1 = {rules:[
  {
    required: true,
    message: <ErrorMesage> Please enter address.</ErrorMesage>
  },
  {
    max: 100,
    message: <ErrorMesage> Maximum character limit for Address is 100. Please correct to Proceed. </ErrorMesage>
    },
],
onchangePattern:/^.{0,100}$/,
regex: /^.{1,100}$/
}

const line2 = {rules:[
  {
    max: 100,
    message: <ErrorMesage> Maximum character limit for Address is 100. Please correct to Proceed. </ErrorMesage>
    }
],
onchangePattern:/^.{0,100}$/,
regex: /^.{0,100}$/
}

const line3 = {rules:[
  {
    max: 100,
    message: <ErrorMesage> Maximum character limit for Address is 100. Please correct to Proceed. </ErrorMesage>
    },
],
onchangePattern:/^.{0,100}$/,
regex: /^.{0,100}$/
}

const zipCode = {rules:[
    {
        required: true,
        message:<ErrorMesage> Please specify a zip code in Vanguard Mutual Fund Account’s donor section 1 to continue </ErrorMesage>
    },
    {
        min:5,
        message: <ErrorMesage> Enter Zip Code of donor in Vanguard Mutual Fund Account’s donor section 1 to continue. Must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue </ErrorMesage>
    }
], onchangePattern:/^[0-9]{0,9}$/,
regexUS: /^([0-9]{5}\-[0-9]{4})$|^([0-9]{5})$/,
regexNonUS: /^.{1,20}$/ }

const city = {rules:[
  {
    required: true,
    message: <ErrorMesage> Please enter city.</ErrorMesage>
  },
  {
    min: 2,
    message: <ErrorMesage> City name is too short. Please correct to continue. </ErrorMesage>
  }
], onchangePattern:regexMap.city,
regex: /^.{2,100}$/ }

const state = {rules:[
  {
    required: true,
    message: <ErrorMesage> Please enter state.</ErrorMesage>
  },
  {
    min: 2,
    message: <ErrorMesage>State name is too short. Please correct to continue.</ErrorMesage>
  }
], onchangePattern:/^[a-zA-Z ]{0,100}$/,
regex: /^[a-zA-Z ]{2,100}$/ }

const country = {rules:[
  {
    required: true,
    message: <ErrorMesage> Please select country.</ErrorMesage>
  }
], onchangePattern:/^.*$/}

const addressType = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please select address type.</ErrorMesage>
  },
  {
    pattern: /^.*\b(Business|Home|Mailing|Physical|Summer|Winter|Other)\b.*$/,
    message: <ErrorMesage>Please select address type.</ErrorMesage>
  }
], onchangePattern:/^.*$/ }

const relationToDonor = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter relationship.</ErrorMesage>
  }
], onchangePattern:/^.*$/ }

const taxIdNumber = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter the private foundation's nine-digit tax ID number.</ErrorMesage>
  },
  {
    pattern: /^(?=.{9,11}$)((?=.{11}$)(([1-9]+-[0-9]+-[0-9]+))|(?=.{10}$)([1-9]+-[0-9]+)|([0-9]{9}))$/,
    message: <ErrorMesage>You must enter a numeric nine-digit Tax ID Number with up to two dashes. Ex. 12-3456789 or 123-45-6789</ErrorMesage>
  }
], onchangePattern:/^[0-9-]{0,11}$/,
regex: /^(?=.{9,11}$)((?=.{11}$)(([1-9]+-[0-9]+-[0-9]+))|(?=.{10}$)([1-9]+-[0-9]+)|([0-9]{9}))$/ }

const VGAccountNumber = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter Vanguard account number.</ErrorMesage>
  },
  {
    min: 8,
    message: <ErrorMesage>Vanguard account number is too short.  Please correct to continue.</ErrorMesage>
  }
], onchangePattern:/^[0-9]{0,12}$/,
regex: /^[0-9]{8,12}$/ }

const accountNumber = {rules:[
  {
    max: 100,
    message: <ErrorMesage> Account number is too short.  Please correct to continue.</ErrorMesage>
  }
], onchangePattern:/^.{0,100}$/,
regex: /^.{0,100}$/ }

const tickerSymbol = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter a ticker symbol. For example, Vanguard Total Stock Market Index Fund Admiral Shares ticker is VTSAX.</ErrorMesage>
  },
  {
    max: 50,
    message: <ErrorMesage>Maximum character limit for Ticker Symbol is 50. Please correct to Proceed.</ErrorMesage>
  }
], onchangePattern:/^.{0,50}$/,
regex: /^.{1,50}$/ }

const fundNumber = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter fund number.</ErrorMesage>
  },
  {
    max: 20,
    message: <ErrorMesage>Maximum character limit for Fund Number is 10. Please correct to Proceed.</ErrorMesage>
  }
], onchangePattern:/^.{0,20}$/,
regex: /^.{1,20}$/ }

const fundName = {rules:[
    {
        required:true,
        message:<ErrorMesage>Please enter fund name.</ErrorMesage>
    },
    {
        max:150,
        message:<ErrorMesage>Maximum character limit for Fund Name is 150. Please correct to Proceed.</ErrorMesage>
    }
], onchangePattern:/^.{0,150}$/,
regex: /^.{1,150}$/ }

const numberofShares = {rules:[
    {
        required:true,
        message:<ErrorMesage>Please enter number of shares.</ErrorMesage>
    },
    {
        max:14,
        message:<ErrorMesage>Please enter a value less than 9999999. For more shares, enter two transactions. </ErrorMesage>
     },
    {
      pattern: /^[0-9,]{1,9}(\.\d{1,4})?%?$/,
      message: <ErrorMesage> Please specify a valid number for Number of shares of Mutual Fund held at Vanguard  to continue </ErrorMesage>
    }
], onchangePattern:/^[0-9]{0,7}(\.\d{0,4})?%?$/,
regex: /^[0-9,]{1,9}(\.\d{1,4})?%?$/ }

const securityName = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter security name.</ErrorMesage>
  },
  {
    min: 2,
    message: <ErrorMesage>Security name is too short. Please correct to continue.</ErrorMesage>
  },
  {
    max: 100,
    message: <ErrorMesage>Maximum character limit for Security Name is 100. Please correct to Proceed.</ErrorMesage>
  }
], onchangePattern: /^.{0,100}$/,
regex: /^.{2,100}$/}

const accountType = {rules:[
  {
    required: true,
    message: <ErrorMesage> Please specify Security Name of Security held at VBS 1 to continue.</ErrorMesage>
  },
  {
    min: 2,
    message: <ErrorMesage>Security Name of Security held at VBS 1 is too short.</ErrorMesage>
  },
  {
    max: 100,
    message: <ErrorMesage>Maximum character limit for Security Name is 10. Please correct to Proceed.</ErrorMesage>
  }
], onchangePattern:/[0-9$]*$/
}

const donorAdvisedFundName = {rules:[
  {
    required: true,
    message: <ErrorMesage> Please specify Donor Name of Check 1 to continue. </ErrorMesage>
  },
  {
    min: 2,
    message: <ErrorMesage> Donor Name of Check 1 is too short.</ErrorMesage>
  },
], onchangePattern:/^.{0,100}$/,
regex: /^.{2,100}$/ }

const amount = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter contribution amount.</ErrorMesage>
  }
], onchangePattern:/^[0-9]{0,9}(\.\d{0,2})?%?$/
}

const holdingFirm = {rules:[
  {
    required: true,
    message: <ErrorMesage>Please enter name of firm currently holding the asset.</ErrorMesage>
  },
  {
    max: 100,
    message: <ErrorMesage> Maximum character limit for Originating Firm is 100. Please correct to Proceed. </ErrorMesage>
  },
], onchangePattern:/^.{0,100}$/,
regex: /^.{1,100}$/ }

const numberofSharesAssetHeldOutsideVG = {
  rules: [
    {
        required: true,
        message: <ErrorMesage>Please enter number of shares.</ErrorMesage>
    },
    {
        max: 14,
        message: <ErrorMesage>Please enter a value less than 9999999. For more shares, enter two transactions. </ErrorMesage>
    },
    {
      pattern: /^(?!0*(\.0+)?$)([0,-9]*(?:\.[0-9]{0,4})?)$/,
      message: <ErrorMesage> Please enter number of shares.</ErrorMesage>
    }
  ], onchangePattern: /^[0-9]{0,7}(\.\d{0,4})?%?$/,
  regex:  /^(?!0*(\.0+)?$)([0,-9]*(?:\.[0-9]{0,4})?)$/
}

export const Rules = {
  firstName, lastName, name, donorType, line1, line2, line3,  zipCode, city, state, country, accountType, donorAdvisedFundName,
  addressType, taxIdNumber, VGAccountNumber, accountNumber ,tickerSymbol, fundName, fundNumber, securityName, numberofShares, amount, holdingFirm,
  numberofSharesAssetHeldOutsideVG,relationToDonor
}



